import { render, staticRenderFns } from "./CrearTipoView.vue?vue&type=template&id=6539341d&"
import script from "./CrearTipoView.vue?vue&type=script&lang=js&"
export * from "./CrearTipoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports